<template>
  <div id="product" class="bg-silver section-container p-t-20">
    <div class="container">
      <ol class="breadcrumb m-b-10 f-s-12" v-if="product">
        <!-- <li>
          <router-link :to="{ name: 'Home'}">Home</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Product', params: { slug: product.slug }}">{{ product.name }}</router-link>
        </li> -->
        <li style="position: absolute; right: 10px; top: 5px" v-if="product.status.label === 'Editing'">
          <router-link class="btn btn-primary" :to="{ name: 'EditProductDeveloper', params: { slug: product.slug }}"><i class="fa fa-edit pr-2"></i>Edit App</router-link>
        </li>
      </ol>
      <!-- BEGIN product -->
      <div class="product" v-if="product">
        <div class="product-detail">
          <div class="product-image">
            <div class="product-main-image">
              <img :src="product.logo.slug | media({width: 300, crop: 'box'})" :alt="`Logo ${product.name}`">
            </div>
            <!-- Screenshots gallery -->
            <div v-if="images.length" style="width: 320px; padding: 0 20px;">
              <gallery :images="images" :index="index" @close="index=null"></gallery>
              <div class='row'>
                <div class='col-md-12'>
                  <div class="carousel slide" data-ride="carousel" id="media" data-interval="false">
                    <div class="carousel-inner">
                      <div class="item" :class="{ 'active': (setIndex === 0) }" v-for="(imagesSet, setIndex) in imagesGroupedForSlider" :key="setIndex">
                        <div class="row">
                          <div class="col-md-4 p-0 m-0" v-for="(image, imgIndex) in imagesSet" :key="imgIndex">
                            <div class="image mr-1 border" @click="index=imageIndex" :style="{ backgroundImage: 'url(' + image + ')', height:'62px', width: '95px', backgroundSize: 'cover', boxShadow: '0px 6px 10px #c0c3c6' }"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <a class="left carousel-control" href="#media" data-slide="prev" v-if="imagesGroupedForSlider.length > 1">
                      <i class="fa fa-angle-left"></i>
                    </a>
                    <a class="right carousel-control" href="#media" data-slide="next" v-if="imagesGroupedForSlider.length > 1">
                      <i class="fa fa-angle-right"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="product-info">
            <div class="product-info-header">
              <div class="product-actions pull-right text-center" v-if="product.status.label === 'Approved'">
                <button type="button" v-if="!purchase" class="btn btn-success btn-lg" @click.prevent.stop="install">Get this App <i class="fa fa-download" aria-hidden="true"></i>
                </button>
                <div v-if="purchase" class="text-muted">You purchased {{ product.name }} on {{ purchase.created | moment('YYYY-mm-DD') }}</div>
                <router-link v-if="purchase" class="btn btn-success btn-lg" :to="{ name: 'Install', params: { id: purchase._id }}">
                  <i class="fa fa-download" aria-hidden="true"></i> Install
                </router-link>
              </div>
              <h1 class="product-title">{{ product.name }} <span class="badge" :class="product.status.class" v-if="product.status.label !== 'Approved'">{{ product.status.label }}</span></h1>
              <p class="text-muted"> By {{ product.author.nickname }}</p>
              <!-- Ratings -->
              <rating class="pull-left m-r-10" :rate="product.stats.rate"></rating>
              <span v-if="product.stats.rate">({{product.stats.rate}}/5) |</span> {{product.stats.reviews}} review{{product.stats.reviews>1? 's':''}} | {{product.stats.users}} user{{product.stats.users>1? 's':''}}
            </div>
            <!-- Categories and certifications -->
            <ul class="product-info-list">
              <li v-if="product.categories">
                <i class="fa fa-circle"></i>
                <b>Area of activity:</b> {{ product.categories.join(', ') }}</li>
              <li>
                <i class="fa fa-circle"></i>
                <b>Regulatory Status:</b> {{ product.certifications | certifications }}</li>
              <li class="mb-4 text-capitalize">
                <i class="fa fa-circle"></i>
                <b>Third-Party Viewer:</b> {{ product.viewer || 'Standalone' }}</li>
            </ul>
            <div class="product-warranty">
              <p class="text-justify word-wrap">{{ product.overview }}</p>
            </div>
          </div>
        </div>
        <div class="product-tab">
          <div class="nav nav-tabs"></div>
          <div id="product-tab-content" class="tab-content">
            <!-- BEGIN #product-desc -->
            <div class="tab-pane fade active in" id="product-desc">

              <!-- description -->
              <div class="product-desc" v-if="product.description">
                <div class="desc">
                  <h4>Description</h4>
                  <p class="text-justify word-wrap no-h1-h2-h3" v-html="product.description"></p>
                </div>
              </div>
              <div class="product-desc" v-if="product.features">
                <div class="desc">
                  <h4>Features</h4>
                  <p class="word-wrap no-h1-h2-h3" v-html="product.features"></p>
                </div>
              </div>
              <!-- BEGIN product-desc videos -->
              <div class="product-desc">
                <div class="desc">
                  <h4>Videos</h4>
                  <p v-if="product.videos && !product.videos.length">No videos</p>
                  <p>
                    <iframe v-for="(video, videoIndex) in product.videos" :key="videoIndex" width="300" height="200" :src="video.src" class="mr-2"></iframe>
                  </p>
                </div>
              </div>
              <div class="product-desc">
                <div class="desc">
                  <h4>Publications</h4>
                  <p v-if="product.publications && !product.publications.length">No publications</p>
                  <ul>
                    <li :key="pub.link" v-for="pub in product.publications">
                      <a :href="pub.link" target="_new"><strong>{{ pub.title }}</strong></a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="product-desc">
                <div class="desc">
                  <h4>Reviews</h4>
                  <div class="row mb-4">
                    <div class="col-lg-6">
                      <p>
                        <rating class="rating-lg m-r-10 pull-left" :rate="product.stats.rate"></rating>
                        <span style="font-size: 24px"> ({{ product.stats.rate }}/5) </span>
                      </p>
                      <p v-if="product.reviews && !product.reviews.length">No reviews</p>
                      <div :key="review.rate" v-for="review in product.reviews">
                        <hr>
                        <review :item="review"></review>
                      </div>
                    </div>
                    <div class="col-lg-6 text-center">
                      <!-- count stars -->
                      <rating-stats :stats="product.ratings.stats"></rating-stats>
                    </div>
                  </div>
                </div>
              </div>
              <div class="product-desc" v-if="product.systemRequirement">
                <div class="desc">
                  <h4>System requirement</h4>
                  <p class="word-wrap no-h1-h2-h3" v-html="product.systemRequirement"></p>
                </div>
              </div>
              <div class="product-desc" v-if="product.lastUpdates">
                <div class="desc">
                  <h4>Last updates</h4>
                  <p class="word-wrap no-h1-h2-h3" v-html="product.lastUpdates"></p>
                </div>
              </div>
              <div class="product-desc">
                <div class="desc">
                  <h4>Technical details</h4>
                  <p>
                    <ul>
                      <li>
                        <strong>Version: </strong>{{ product.technicalDetails.version }}</li>
                      <li>
                        <strong>Size: </strong>{{ displaySize }}</li>
                      <li v-if="product.technicalDetails.createdDate">
                        <strong>Created on: </strong>{{ product.technicalDetails.createdDate | moment('MM-DD-YYYY') }}</li>
                      <li v-if="product.technicalDetails.updatedDate">
                        <strong>Last update: </strong>{{ product.technicalDetails.updatedDate | moment('MM-DD-YYYY')}}</li>
                    </ul>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import Rating from '@/components/Rating'
import RatingStats from '@/components/RatingStats'
import Review from '@/components/Review'
import VueGallery from 'vue-gallery'
import Vue from 'vue'
import Vuex from 'vuex'

export default {
  name: 'Product',
  data() {
    return {
      product: null,
      images: [],
      index: null,
      purchase: null
    }
  },
  components: {
    gallery: VueGallery,
    rating: Rating,
    review: Review,
    'rating-stats': RatingStats
  },
  computed: {
    ...Vuex.mapGetters(['isAuthenticated', 'authToken']),
    imagesGroupedForSlider() {
      const size = 3
      return _.map(this.images, (item, index) => {
        return index % size === 0 ? this.images.slice(index, index + size) : null
      }).filter(item => item)
    },
    displaySize() {
      const sizeBin = this.product.technicalDetails.size
      const divid = (sizeBin > 1000 * 1000) ? { nb: 1000 * 1000, unit: ' MB' } : { nb: 1000, unit: ' KB' }
      return Math.round(this.product.technicalDetails.size / divid.nb * Math.pow(10, 1)) / Math.pow(10, 1) + divid.unit
    }
  },
  created: function () {
    this.fetchData()
  },
  watch: {
    product: function (val) {
      if (this.isAuthenticated) {
        this.checkPurchase()
      }
    }
  },
  methods: {
    checkPurchase: function () {
      this.$http
        .get(`purchase`, {
          params: {
            conditions: { product: this.product._id }
          }
        })
        .then(
          response => {
            this.purchase = response.data[0]
          },
          error => {
            // error callback
            console.log(error)
          }
        )
    },
    fetchData: function () {
      const viewStatus = {
        'edit': { 'label': 'Editing', 'class': 'badge-warning' },
        'pending': { 'label': 'Waiting for approval', 'class': 'badge-info' },
        'declined': { 'label': 'Declined', 'class': 'badge-danger' },
        'approved': { 'label': 'Approved', 'class': 'badge-success' },
        'closed': { 'label': 'Closed', 'class': 'badge-default' }
      }
      let productUri = 'product/public/'
      /* if (this.isAuthenticated) {
        productUri = 'product/dev/'
      } */
      this.$http
        .get(`${productUri}${this.$route.params.slug}`, {
          params: { populate: 'author' }
        })
        .then(
          response => {
            this.product = response.body
            this.images = (this.product.screenshots || []).map(it =>
              Vue.filter('media')(it.slug, {})
            )
            // formating app status
            this.product.status = viewStatus[this.product.status]
            this.product.logo = this.product.logo || {}
            this.product.videos = this.product.videos || []
            this.product.reviews = this.product.reviews || []
          },
          response => {
            // error callback
            console.log(response)
          }
        )
    },
    install: function () {
      if (!this.isAuthenticated) {
        // console.log(this.$route.path)
        this.$router.push({
          name: 'Login',
          query: { redirect: this.$route.path }
        })
      } else {
        this.$http.put(`purchase`, { product: this.product._id }).then(
          response => {
            const purchase = response.data
            if (purchase.status === 'paid') {
              this.$router.push({
                name: 'Install',
                params: { id: purchase._id }
              })
            }

            if (purchase.status === 'init') {
              console.log('Paid product')
            }
          },
          error => {
            // error callback
            console.log(error)
          }
        )
      }
    }
  }
}
</script>
<style>
.product-desc .desc {
  width: 100%;
}

.product-image {
  width: 320px;
}

.product-main-image {
  margin-left: 0;
  padding: 20px;
  height: 320px;
  width: 320px;
  text-align: center;
}

.rating span.fa-star {
  display: inline-block;
  color: #999;
  font-size: 85%;
}

.rating span.fa-star.full {
  color: #FF8500;
}

.product-warranty {
  border: none !important;
}

</style>
<style scoped>
.carousel-control {
  width: 20px;
}

.carousel .carousel-inner,
.carousel .carousel-inner .item,
.slider .carousel {
  min-height: unset;
}

</style>



// WEBPACK FOOTER //
// src/pages/public/Product.vue